<!--suppress ALL -->
<template>
  <div class="file-upload">
    <div v-if="isDropped">
      <div :class="`file-droped ${draggedClassName}`" @dragover.prevent
           @drop='onDropFile' @dragleave='draggedClassName=""'
           @dragenter='draggedClassName="on-drag-enter"'>
        <p class="title is-5">{{title}}</p>
        <p class="text-mute mb-5">
          <span>atau pilih file</span>
          <a class="has-up-btn">
            <span>disini</span>
            <input :key="inputKey" @change="onUploadFile" :multiple="isMultiple" :accept='aceptFile' type="file">
          </a>
        </p>
        <slot></slot>
        <p v-if="hasSubtitle" class="text-mute">{{subtitle}}</p>
      </div>
      <div v-if="hasFiles" class="file-list">
        <table class="table is-striped is-bordered">
          <thead>
          <tr>
            <th>Nama file</th>
            <th>UkuranRequest</th>
            <th>Aksi</th>
          </tr>
          </thead>
          <tbody v-if="hasSingleFile">
          <tr>
            <td>{{fileNameFormated}}</td>
            <td>{{files.size / 1000}} kb</td>
            <td><a class="button is-danger" @click="onDeleteFile"><i class="fas fa-trash-alt"></i></a></td>
          </tr>
          </tbody>
          <tbody v-else>
          <tr v-for="(file, index) in files"
              :key="`file-${index}`">
            <td>
              <template v-if="$scopedSlots.customSlotTable || $slots.customSlotTable">
                <slot name="customSlotTable"
                      :index="index"
                      :fileName="(file.name.length > 20 ? file.name.substr(0,17)+'...' : file.name)"/>
              </template>
              <template v-else>
                {{file.name.length > 20 ? file.name.substr(0,17)+'...' : file.name}}
              </template>
            </td>
            <td>{{!Boolean(file && file.updated) ? `${(file.size / 1000)} kB` : file.size}}</td>
            <td>
              <a v-if="!Boolean(file && file.updated)" class="button is-danger" @click="onDeleteFile(index)">
                <i class="fas fa-trash-alt"></i>
              </a>
              <a v-else class="button is-danger" disabled="">
                <i class="fas fa-trash-alt"></i>
              </a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-else>
      <div class="file has-name is-fullwidth">
        <label class="file-label" :data-tooltip="toolTip"
               :class="[{'tooltip': toolTip.length}, fileLabelClass]">
          <input class="file-input" @change="onUploadFile"
                 :accept='aceptFile' title=" " type="file" :key="inputKey">
          <span class="file-cta">
            <span class="file-icon">
              <i class="far" :class="iconName"></i>
            </span>
            <span class="file-label">
              Pilih file
            </span>
          </span>
          <span class="file-name">
            {{fileNameFormated}}
          </span>
        </label>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import {Component, Vue, Prop} from 'annotation';
  import {acceptFormatFiles} from '../../util/FormatUtils';
  import {isEmpty, isNil, cloneDeep} from 'lodash';

  @Component
  /**
   * use isDropped if u want multi file!
   */
  export default class GUpload extends Vue {

    @Prop({default: 'Seret dan tarik file kesini'})
    public title: string;

    @Prop({default: '', type: String})
    public subtitle: string;

    @Prop({default: '', type: String})
    public fileLabelClass: string;

    @Prop({default: acceptFormatFiles})
    public aceptFile: string;

    @Prop({default: false, type: Boolean})
    public isMultiple: boolean;

    @Prop({default: false, type: Boolean})
    public isAllowReplace: boolean;

    @Prop({default: false, type: Boolean})
    public skipCheckingFormatFile: boolean;

    @Prop({default: 5})
    public maxSizeMb: number;

    @Prop({default: false, type: Boolean})
    public isDropped: boolean;

    @Prop({
      default: null
    })
    public files: any;

    @Prop({type: String, default: "fa-upload"})
    public iconName: string;

    public inputKey: any = Math.random();

    public get hasFiles() {
      return (!isEmpty(this.files) && this.isMultiple) || (this.files instanceof File);
    }

    public get toolTip() {
      const {files, maxSizeMb, isAllowReplace} = this;

      return files === null ? ('Maksimal ukuran file upload ' + maxSizeMb + ' Mb') :
        isAllowReplace ? '' : 'File yang diupload maks satu! Hapus file untuk mengganti'
    }

    public get hasSubtitle() {
      return !isEmpty(this.subtitle);
    }

    public get hasSingleFile() {
      return !isNil(this.files) && !this.isMultiple;
    }

    public get fileNameFormated() {
      const {isMultiple} = this;

      if (isMultiple) {
        return '';
      }

      const name = this.files instanceof File ? this.files.name : 'Belum ada File';

      return name.length > 25 ? (name.substr(0, 22) + '...') : name;
    }

    public draggedClassName: string = '';

    public mounted() {
      this.initEvent();
    }

    public destroyed() {
      this.initEvent(false);
    }

    public onDeleteFile(index = null) {
      if (this.isMultiple) {
        const files = cloneDeep(this.files);

        if (files && files.length) {
          files.splice(index, 1);
          this.$emit('update:files', files);
        }
      } else {
        this.$emit('update:files', null);
      }

      this.inputKey = Math.random();
    }

    public initEvent(isAddEventListener = true) {
      ['drop', 'dragenter', 'dragleave'].forEach((item) => {
        if (isAddEventListener) {
          window.addEventListener(item, (e) => {
            e.stopPropagation();
            e.preventDefault()
          }, false);
        } else {
          window.removeEventListener(item, (e) => {
            e.stopPropagation();
            e.preventDefault()
          }, false);
        }
      });
    }

    public onUploadFile(e) {
      this.processFiles(e.target.files);
    }

    public onDropFile(e) {
      e.stopPropagation();
      e.preventDefault();

      this.processFiles(e.dataTransfer.files);
    }

    public processFiles(param) {
      const context = this
      const {isMultiple, files, maxSizeMb, aceptFile, isAllowReplace, skipCheckingFormatFile} = context;
      const fileList = Array.from(param);
      const isFileHasValidFormat = fileList.reduce((accu: boolean, file: any) => {
        const fileNameSplit = file.name.split('.');
        const fileFormat = fileNameSplit[fileNameSplit.length - 1].toLowerCase();

        return accu && aceptFile.includes(`.${fileFormat}`);
      }, true);

      const totalSizeFile = fileList
        .concat(isMultiple ? files : [])
        .filter((file: any) => file instanceof File)
        .reduce((accu: number, file: any) => accu + file.size, 0);

      const isMaxSizeNotExceeds = (maxSizeMb > 0 && (totalSizeFile / 1000000 < this.maxSizeMb)) || maxSizeMb === 0;

      if (!isMultiple && !isNil(files) && !isAllowReplace) { // if is single file and property files has current file
        alert(this.$t('text.max_upload_1'));
      } else if ((!isFileHasValidFormat || !isMaxSizeNotExceeds) && !skipCheckingFormatFile) {
        alert(this.$t('text.file_not_suported_exceed', {mb: this.maxSizeMb}));
      } else {
        let files = null;
        if (isMultiple) {
          files = (cloneDeep(this.files) || []).concat(fileList);
        } else {
          files = fileList[0];
        }

        this.$emit('update:files', files);
        this.$emit('file-added', files);
      }

      this.inputKey = Math.random();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../style/variables_function";

  .file-upload {
    .file-label {
      overflow: inherit;
    }

    input.file-input {
      /*opacity: 1.0 !important;*/
      overflow: hidden;
    }

    .file-droped {
      background-color: $grey-lighten;
      height: 300px;
      border-radius: 6px;
      border: 3px solid $grey-lighter;
      border-style: dotted;
      @include fl_col;
      justify-content: center;
      align-items: center;

      p {
        margin-bottom: 0rem;

        &.title {
          font-weight: 500;
        }

        &.mb-5 {
          margin-bottom: .5rem;
        }
      }

      &.on-drag-enter {
        background-color: white;
        @include b_sh_def;
        transition: .25s;
        border: none;
      }

      margin-bottom: 1rem;

      a.has-up-btn {
        margin-left: .25rem;
        position: relative;
        cursor: pointer;

        input, span {
          cursor: pointer;
        }

        input {
          top: 0;
          left: 0;
          opacity: 0;
          @include fill_fixed_absolute();
        }
      }
    }

    .file-list table {
      width: 100%;

      thead tr th {
        font-weight: 500;
      }

      tbody tr td, thead tr th {
        font-size: .9rem;

        &:last-child {
          width: 70px;
        }
      }
    }
  }
</style>
